import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Button, Form } from "react-bootstrap";

import { tableHeaders } from "../hooks/constants";
import CalendarQuoteModal from "../containers/Modals/CalendarQuoteModal";

import TableContainer from "../containers/Tables/TableContainer";
import DatePicker from "../components/DatePicker";
import {
  load_quote_list,
  load_user_summary_from_id,
} from "../actions/agenda_content";
import { load_actives_list } from "../actions/management_content";
import { load_users_short } from "../actions/user_content";
import { checkAuthenticated } from "../actions/auth";
import { useDispatch } from "react-redux";

const RegistroCitasPage = () => {
  const dispatch = useDispatch();
  const { pacienteId } = useParams();
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get("serviceId");

  const nowDate = new Date();
  const [dateValues, setDateValues] = useState({
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
  });

  const [modalShow, setModalShow] = useState(false);
  const [modalId, setModalId] = useState(false);

  const [dataState, setDataState] = useState("loading");

  const [quotesList, setQuotesList] = useState([]);
  const [citasResumen, setCitasResumen] = useState({
    id: pacienteId,
    rut: "",
    paciente: "Paciente",
    service: "Servicio",
    citas: null,
    assistance_confirmed: null,
    price: null,
    payed: null,
    pending: null,
    suspended: null,
  });
  const [quoteOptions, setQuoteOptions] = useState({
    services: [],
    professionals: [],
  });
  const fetchQuoteOptions = async () => {
    const actives = await load_actives_list({ active_type: "service" });
    const professionals = await load_users_short();
    setQuoteOptions({
      services: actives.service,
      professionals: professionals,
    });
  };

  const handleEventEdit = (quoteId) => {
    setModalId(quoteId);
    setModalShow(!modalShow);
  };

  const fetchPatientSummary = async () => {
    const { year, month } = dateValues;

    const data = await load_user_summary_from_id(pacienteId, {
      year,
      month,
      service: serviceId,
    });
    if (data) {
      setCitasResumen(data);
      setDataState("default");
    } else {
      setDataState("notFound");
    }
  };
  const fetchPatientQuotesList = async () => {
    const { year, month } = dateValues;
    const data = await load_quote_list({
      year,
      month,
      service: serviceId,
      patient: pacienteId,
    });
    if (data) {
      setQuotesList(data.results);
    }
  };

  const tableConfig = {
    headers: tableHeaders.quoteTable,
    checkable: false,
    detailFunction: handleEventEdit,
    listData: quotesList,
  };

  useEffect(() => {
    dispatch(checkAuthenticated());
    fetchQuoteOptions();
    fetchPatientSummary();
    fetchPatientQuotesList();
  }, [dateValues]);
  const objViews = {
    loading: <h1>Cargando...</h1>,
    notFound: <h1>No encontrado...</h1>,
    default: (
      <div className="content gap-2">
        <div className="container d-flex flex-column justify-content-evenly">
          <div className="record-header">
            <h1 className="text-center">
              Registro de Citas{" "}
              {serviceId
                ? `por ${citasResumen.service} de ${citasResumen.paciente}`
                : `de ${citasResumen.paciente}`}
            </h1>
          </div>
          <div className="record-body d-flex flex-column">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
              <h2 className="mb-0">Desglose Pago</h2>
              <DatePicker
                dateValues={dateValues}
                setDateValues={setDateValues}
              />
            </div>
            <div className="patient-breakdown d-flex flex-column w-100">
              <div className="d-flex flex-wrap justify-content-evenly mb-2 w-100">
                <span>Total de citas: {citasResumen.citas}</span>
                <span>Asistencias: {citasResumen.assistance_confirmed}</span>
                <span>Suspendidas: {citasResumen.suspended}</span>
              </div>
              <div className="patient-breakdown-types w-100 mb-2">
                <h5 className="breakdown-type">Mensual</h5>

                <div className="breakdown-list d-flex flex-wrap gap-2">
                  <div className="breakdown-item">
                    <div className="breakdown-item-title">
                      <p className="fs-5 fw-bold m-0">Pagado</p>
                    </div>
                    <div className="breakdown-item-value">
                      <p className="fs-4 fw-bold m-0">${citasResumen.payed}</p>
                    </div>
                    <div className="breakdown-item-value">
                      <p className="fs-5 m-0">
                        {(
                          (citasResumen.payed / citasResumen.price) *
                          100
                        ).toFixed(1)}
                        %
                      </p>
                    </div>
                  </div>
                  <div className="breakdown-item">
                    <div className="breakdown-item-title">
                      <p className="fs-5 fw-bold m-0">Pendiente</p>
                    </div>
                    <div className="breakdown-item-value">
                      <p className="fs-4 fw-bold m-0">
                        ${citasResumen.pending}
                      </p>
                    </div>
                    <div className="breakdown-item-value">
                      <p className="fs-5 m-0">
                        {(
                          (citasResumen.pending / citasResumen.price) *
                          100
                        ).toFixed(1)}
                        %
                      </p>
                    </div>
                  </div>
                  <div className="breakdown-item">
                    <div className="breakdown-item-title">
                      <p className="fs-5 fw-bold m-0">Total Esperado</p>
                    </div>
                    <div className="breakdown-item-value">
                      <p className="fs-4 fw-bold m-0">${citasResumen.price}</p>
                    </div>
                    <div className="breakdown-item-value">
                      <p className="fs-5 m-0">100.0%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="quotes-table">
              <div className="quotes-table-header d-flex justify-content-between mb-2">
                <h4>Citas</h4>
              </div>
              <div className="quotes-table-body mb-2">
                <TableContainer tableConfig={tableConfig} />
              </div>
              {/* <div className="quotes-table-footer d-flex justify-content-between">
                <Button variant="primary d-flex align-items-center gap-2">
                  Deseleccionar
                </Button>
                <div className="d-flex table-options gap-2">
                  <Form.Select aria-label="Default select example">
                    <option value="3">Marcar Como Pagado</option>
                  </Form.Select>
                  <Button variant="primary d-flex align-items-center gap-2">
                    Confirmar Accion
                  </Button>
                </div>
              </div> */}
            </div>
          </div>
          <CalendarQuoteModal
            show={modalShow}
            onHide={() => {
              setModalId(null);
              setModalShow(false);
              fetchPatientQuotesList();
            }}
            quoteId={modalId}
            quoteOptions={quoteOptions}
          />
        </div>
      </div>
    ),
  };
  return objViews[dataState];
};

export default RegistroCitasPage;
